import { render, staticRenderFns } from "./EditKitchen.vue?vue&type=template&id=fd22d062&"
import script from "./EditKitchen.vue?vue&type=script&lang=js&"
export * from "./EditKitchen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports